"use client";

import applyForJob from "@/actions/job";
import Alert, { AlertType } from "@/components/Alerts";
import { EmailShareModal } from "@/components/Jobs/EmailShareModal";
import React from "react";
import toast from "react-hot-toast";
import FormComponent from "../FormComponent";

export interface JobFormActionProps {
  job: any;
  type: "email" | "link";
  title: string;
  disabled?: boolean;
}

const JobFormAction: React.FC<JobFormActionProps> = ({ job, type, title, disabled }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <form className="my-2 w-full">
        <FormComponent
          formAction={async () => {
            const result = await applyForJob(job.id);
            if (!result) {
              // Sentry error
              toast.custom(<Alert type={AlertType.Error} content="Something went wrong" />);
              return;
            }

            if (result.error) {
              // @ts-ignore
              const error = result.error?._errors ? result.error?._errors?.join(", ") : result.error?.message;
              toast.custom(<Alert type={AlertType.Error} content={error} />);
              return;
            }

            if (result.success) {
              if (window.location) {
                if (type === "email") {
                  setOpen(true);
                } else if (type === "link") {
                  window.location.href = job.applyUrl;
                }
              }
            }
          }}
          title={title}
          className={`btn-outline hover:btn-outline w-full min-w-[200px] ${type === "email" ? "btn-outline" : "btn-active"}`}
          disabled={disabled}
        />
      </form>
      {type === "email" && <EmailShareModal email={job.jobReachEmail} open={open} onClose={() => setOpen(false)} />}
    </>
  );
};

export default JobFormAction;
